/**
 * Show table of students showing how many standards in each grade they have completed
 */
(function(){
  angular.module('EdxClassroomReportModule')
    .component('edxStudentProficienciesTable', {
      bindings: {
        /**
         * {
         *   id: <student user id>,
         *   first_name: <student first name>,
         *   last_name: <student last name>,
         *   total_session_time: <minutes of session time over specified time range>,
         *   lesson_count: <number of lessons completed over time range>,
         *
         *   // Standard information for each grade K - 8
         *   grades: [
         *     {
         *       grade: <grade as number (0 - 8)>,
         *       level_id: <grade as ID (1 - 9)>,
         *       standards_completed: <number of standards completed for this grade>,
         *       standards_count: <total number of standards available for this grade>
         *     }
         *   ]
         * }
         */
        studentProficiencies: '<',

        /**
         * Grades to display
         * This is an array of the grades that should be displayed
         */
        gradeRange: '<',

        /**
         * Grade to center on
         */
        grade: '<'
      },
      templateUrl: '/resources/components/report/classroom/student-proficiencies/edx-student-proficiencies-table.component.html',
      controller: ['navigation', 'dblAnalyticsProvider', 'authentication', 'customer', EdxStudentProficienciesTable],
      controllerAs: 'vm'
    });

  function EdxStudentProficienciesTable(navigation, analyticsService, authentication, $customer) {
    var vm = this;
    vm.isBts2020Nav = authentication.useBts2020Nav();
    vm.createProgressBarGradient = createProgressBarGradient;
    vm.onClickStudent = onClickStudent;
    vm.onClickPrevGradeArrow = onClickPrevGradeArrow;
    vm.onClickNextGradeArrow = onClickNextGradeArrow;
    vm.sort = sort;
    vm.gradeIndex = -1;
    vm.MAX_GRADE_COLUMNS = vm.isBts2020Nav ? 9 : 5;
    vm.ADDITIONAL_GRADES = Math.floor((vm.MAX_GRADE_COLUMNS - 1) / 2);
    vm.hasPreviousGrade = false;
    vm.previousGrade = undefined;
    vm.hasNextGrade = false;
    vm.nextGrade = undefined;
    vm.displayGrades = [];
    vm.academicStandard = $customer.getAcademicStandard().academic_standard_name;

    vm.$onChanges = function(changes) {
      if (changes.gradeRange || changes.grade) {
        if (vm.gradeRange && vm.grade !== undefined) {
          vm.gradeIndex = Math.max(0, vm.gradeRange.indexOf(vm.grade));
          updateGradeRange();
        }
      }
    };

    /**
     * Determine if sort is ascending or descending
     *
     * true = ascending
     * false = descending
     */
    vm.sortAscending = undefined;

    /**
     * The attribute on which to sort
     */
    vm.sortAttribute = undefined;

    _onInit();

    /**
     * Initialize controller
     * @private
     */
    function _onInit() {
      analyticsService.eventTrack('Show Grade View', {
        category: 'Classroom Overview'
      });

      sort('first_name');
    }

    /**
     * Set the attribute to sort by or flip sort order
     *
     * If the attribute is already the sort attribute then flip the sort order
     *
     * @param attribute
     */
    function sort(attribute) {
      if (attribute === vm.sortAttribute) {
        vm.sortAscending = !vm.sortAscending;
      } else {
        vm.sortAttribute = attribute;
        vm.sortAscending = true;
      }
    }

    function updateGradeRange() {
      // Override selected grade so that the grade selection doesn't read past the front of the array.
      if (vm.gradeIndex - vm.ADDITIONAL_GRADES < 0) {
        vm.gradeIndex = vm.ADDITIONAL_GRADES;
      }
      else if (vm.gradeIndex + vm.ADDITIONAL_GRADES >= vm.gradeRange.length) {
        // If possible, avoid selecting a grade that is too high. ADDITIONAL_GRADES should be as low as the selection
        // goes.
        vm.gradeIndex = Math.max(vm.ADDITIONAL_GRADES, vm.gradeRange.length - 1 - vm.ADDITIONAL_GRADES);
      }

      var startIndex = Math.max(0, vm.gradeIndex - vm.ADDITIONAL_GRADES);
      var endIndex = Math.min(vm.gradeRange.length - 1, vm.gradeIndex + vm.ADDITIONAL_GRADES);

      vm.displayGrades = vm.gradeRange.slice(startIndex, endIndex + 1);
      vm.hasPreviousGrade = startIndex > 0;
      vm.previousGrade = vm.hasPreviousGrade ? vm.gradeRange[startIndex - 1] : undefined;
      vm.hasNextGrade = endIndex < vm.gradeRange.length - 1;
      vm.nextGrade = vm.hasNextGrade ? vm.gradeRange[endIndex + 1] : undefined;
    }

    /**
     * Construct a CSS style for the progress bar
     *
     * This style is applied to individual elements using the style attribute
     *
     * @param total The total number of items represented by the progress bar
     * @param completed The number of completed items represented by the progress bar
     * @returns {string}
     */
    function createProgressBarGradient(total, completed) {
      // style="background: linear-gradient(to right, green 0%, green 25%, white 25%, white)"
      var percent = total > 0 ? 100 * completed / total : 0;

      // Add !important to override the print media style which turns off backgrounds
      return 'background: linear-gradient(to right, #6ABD45 0%, #6ABD45 ' + percent + '%, #F2F2F2 ' + percent + '%, #F2F2F2 100%) !important';
    }

    /**
     * Navigate to the overview for a student
     *
     * @param student studentProficiency object
     */
    function onClickStudent(student) {
      analyticsService.eventTrack('Student Row Clicked - Grade View', {
        category: 'Classroom Overview',
        label: student.id
      });
      var storageContext = JSON.parse(window.localStorage.getItem('context'));
      if (storageContext) {
        storageContext.student = {
          id: student.id,
          firstName: student.first_name,
          lastName: student.last_name,
          name: student.last_name + ', ' + student.first_name,
        };
        window.localStorage.setItem('assignmentContext', JSON.stringify(storageContext));
      }
      navigation.goToItem({id: student.id, type: 'student'});
    }

    function onClickPrevGradeArrow() {
      if (vm.hasPreviousGrade) {
        vm.gradeIndex--;

        if (this.gradeIndex < 0) {
          vm.gradeIndex = 0;
        }

        updateGradeRange();
      }
    }

    function onClickNextGradeArrow() {
      if (vm.hasNextGrade) {
        vm.gradeIndex++;

        if (this.gradeIndex >= this.gradeRange.length) {
          vm.gradeIndex = vm.gradeRange.length - 1;
        }

        updateGradeRange();
      }
    }
  }
})();
